Promise.all([import("angular"), import("utils/config"), import("flash-message")]).then(deps => {
    let [angular, config, showFlash] = deps;
    showFlash = showFlash.default;

    var app = angular.module("tapAssetManager");

    app.factory("referralCodeService", [
        "$http",
        function($http) {
            $http.defaults.headers.common["X-Csrf-Token"] = config.get("csrf_token");
            return {
                update: function(referralCode, cb) {
                    referralCode.isUpdating = true;
                    var url = `/p/programs/${referralCode.program}/referral-code/`;
                    var data = { id: referralCode.id };

                    $http
                        .put(url, data)
                        .success(function(content) {
                            showFlash("success", content);
                            referralCode.isUpdating = false;
                            if (typeof cb === "function") cb();
                        })
                        .error(function(content) {
                            showFlash("danger", content);
                            referralCode.isUpdating = false;
                            if (typeof cb === "function") cb("error");
                        })
                        .finally(function() {
                            referralCode.isUpdating = false;
                        });
                },
            };
        },
    ]);
});
